<template>
  <div class="case-index">
    <AppBar />
    <div class="page-content">
      <div class="page-canvas">
        <!-- <div class="page-background">
          <img :src="require('@/assets/customer/canvas.png')" alt="" />
        </div> -->
        <div class="por-container">
          <div class="page-info">
            <div class="page-info-title">
              客户案例
            </div>
            <div class="page-info-describe">
              为企业创造更大的价值，让客户感动
            </div>
          </div>
        </div>
      </div>
      <div class="case-content-wrap">
        <div class="case-breadcrumb-wrap">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/customercase' }">客户案例</el-breadcrumb-item>
            <el-breadcrumb-item>{{ customerName }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="case-content">
          <div class="case-content-left">
            <div
              v-for="(item, index) in contentList"
              :key="index"
              class="text-module"
            >
              <div class="module-name-wrap">
                <div class="module-icon">
                  <img :src="item.icon" alt="" class="icon" />
                </div>
                <div class="module-title">{{ item.title }}</div>
              </div>
              <div class="module-content-wrap">
                <img
                  v-if="item.img != ''"
                  :src="item.img"
                  alt=""
                  class="content-img"
                />
                <div class="module-content" v-html="item.content"></div>
              </div>
            </div>
          </div>
          <div class="case-content-right">
            <div class="related-products">
              <div class="wrap-name-box">
                <div class="wrap-name">相关产品</div>
              </div>
              <div class="product-list">
                <div
                  v-for="(item, index) in relatedProducts"
                  :key="index"
                  class="product-item"
                >
                  <div class="title">{{ productsList[Number(item)].title }}</div>
                  <div class="describe">{{ productsList[Number(item)].describe }}</div>
                  <div class="product-btn" @click="viewDetails(productsList[Number(item)].id)"> 查看详情 </div>
                </div>
              </div>
            </div>
            <div class="more-cases">
              <div class="wrap-name-box">
                <div class="wrap-name">更多行业案例</div>
              </div>
              <div class="cases-type-list">
                <div
                  v-for="(item, index) in casesTypeList"
                  :key="index"
                  class="cases-type-item"
                  @click="viewCases(item)"
                >
                  {{ item.label }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="enterprise-partner" ref="enterprisePartner">
          <img :src="require('@/assets/home/partner-title.png')" alt="" srcset="" />
          <div ref="enterprisePartnerItemWrap" class="enterprise-partner-item-wrap">
            <div v-for="(item, index) in partnerList" :key="index" class="enterprise-partner-item" :style="{animationDuration: `${partnerList.length * 2}s`}">
              <img :src="item" alt="" srcset="" />
            </div>
            <div v-if="partnerRecursion" style="display:flex">
              <div
                v-for="(item, index) in partnerList"
                :key="index"
                class="enterprise-partner-item"
                :style="{animationDuration: `${partnerList.length * 2}s`}"
              >
                <img :src="item" alt="" srcset="" />
              </div>
            </div>
          </div>
          <!-- <div ref="enterprisePartnerItemWrap" class="enterprise-partner-item-wrap">
            <div v-for="(item, index) in partnerList" :key="index" class="enterprise-partner-item">
              <img :src="require(`@/assets/home/${item}.png`)" alt="" srcset="" />
            </div> -->
        <!-- </div> -->
        </div>
      </div>
      <div class="appointment-demonstration">
        <h4 class="appointment-demonstration-title">了解更多有关华跃产品与服务信息</h4>
        <h5 class="appointment-demonstration-subtitle">您还可以预约我们的产品演示</h5>
        <div class="appointment-demonstration-btn" @click="openBealter">
          <img :src="require('@/assets/home/appointment-demonstration1.png')" alt="" />
          <span>预约产品显示</span>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getContentList, getContentDetail } from '@/api/content';
export default {
  name: 'CaseIndex',
  data () {
    return {
      CaseId: '',
      customerName: '',
      contentList: [
        // {
        //   icon: require('@/assets/customer/icon/text-module1.png'),
        //   title: '客户概况',
        //   img: require('@/assets/customer/customer-img1.png'),
        //   content: '<p style="text-indent: 2em;">广东长虹公司占地48万平方米，建筑面积32万平方米，员工3000余人，是长虹集团棋行华南、进军海外的战略基地。公司在美国、法国、阿尔及利亚、乌克兰、印度、泰国等10个国家设有商务中心，在澳大利亚、印尼、捷克、阿联酋、俄罗斯、香港6个国家和地区设有子公司。公司在坚持自主品牌的同时，与全球诸多知名品牌共同开展OEM/ODM业务，销售网络遍布全球各地，产品远销110多个国家和地区。</p><p style="text-indent: 2em;">公司凭借长虹集团国家级技术中心的强大实力，组建了海外产品研发中心，拥有一支100余人的设计研发团队，专门进行海外产品的研发。目前，公司在致力于新型平板产品开发的同时，还涉及数字芯片、嵌入式软件等关键部件的研发。公司拥有国际领先地位的自动化生产线、贴片机群、注塑机群、插件机群、喷涂、高速冲压等先进设备，还拥有彩电全性能自动测试系统等先进检测设备、设施，并通过了ISO体系及全球CE、UL等认证，符合WEEE、RoHS指令等要求，具备年产平板电视300万台、CRT电视250万台的生产能力，是中国最大的彩电出口基地。</p>',
        // },
        // {
        //   icon: require('@/assets/customer/icon/text-module2.png'),
        //   title: '上线华跃HR系统前管理痛点',
        //   img: require('@/assets/customer/customer-img2.png'),
        //   content: '<ul><li>1、集团管控能力弱：集团HR系统建设没有形成集团统一化管控，各个分子公司数据信息不能及时掌握，人力资源数据分散；</li><li>2、人为记忆多，遗漏风险高：人事系统建设没有形成系统化托管。人事专员仍停留在“人找事做，人记事做”的工作模式；</li><li>3、手工作业多，效率准确率低：现人事方面工作仍需要大量的手工操作，简单的事务性工作重复做，工作效率和数据准确性较低；</li><li>4、缺失深化板块建设，效果难追踪：招聘、培训、绩效流程体系没有通过系统化运行，培训实践效果差，培训结果难追踪难；</li><li>5、数据可视化程度低，决策难：人力、招聘、培训等各项成本统计分析可视化程度底，不便于领导决策；</li><li>6、管理统计分析难：管理方面很难做到对人事信息状况及变化的准确统计与分析；</li></ul>',
        // },
        // {
        //   icon: require('@/assets/customer/icon/text-module3.png'),
        //   title: '上线华跃HR系统后',
        //   img: '',
        //   content: '<ul><li>1、建立HR数字化管理模式：搭建一个集团化、规范化、智能化的人力资源管理平台；形成一个统一 、全面、准确的人力资源业务管理平台；实现完整的人力资源数字化管理，员工自助服务，实时掌握人力成本及人力配备情况。</li><li>2、建立HR业务流程标准化：通过新系统实践并落地做到最专业、最细致、最高效的智能化管理；通过系统全面深化一体系一制度、一工作一流程、一流程一标准的管理模式；</li><li>3、建立数据交互及分析平台：建立以HR系统为中心的信息共享平台，整理、并发掘数据中存在的关键信息并加以分析、利用，提升HR管理竞争优势；通过系统AI智能管理工具及数据BI分析平台，为企业管理者管理及战略决策提供支撑；</li><li>4、提高HR管理效率及战略规划：系统智能预警提醒，发出警告性提示信息，帮助公司提升内部管理，有效预防劳动争议发生；系统流程化管理功能，审核看板管理，降低了人事管理员的工作强度，大大提高了工作效率；系统对人力资源状况的静态结构分析和动态趋势分析，管理人员可以从繁琐的日常工作中解脱出来，将精力放到更富有挑战性和创造性的分析、规划、员工激励和企业战略等工作中。</li></ul>',
        // },
      ],
      productsList: [
        {
          id: 0,
          title: '战略组织',
          describe: '适应于企业组织的定义和调整',
        },
        {
          id: 1,
          title: '员工管理',
          describe: '智能化事务处理模式，解放操作员双手',
        },
        {
          id: 2,
          title: '考勤工时',
          describe: '智能排班与员工自助的考勤工时管理',
        },
        {
          id: 3,
          title: '薪酬福利',
          describe: '一键式薪酬核算与薪资预算管理',
        },
        {
          id: 4,
          title: '人才招聘',
          describe: '建立人才储备机制，形成人才梯队管理',
        },
        {
          id: 5,
          title: '人才培育',
          describe: '三大培训体系，赋能企业人才培养',
        },
        {
          id: 6,
          title: '绩效激励',
          describe: '与企业战略目标绑定，提高企业竞争力',
        },
        {
          id: 7,
          title: '人才发展',
          describe: '打造企业数字化人才发展管理模式',
        },
      ],
      relatedProducts: [],
      casesTypeList: [
        {
          id: 1,
          label: '五金行业',
        },
        {
          id: 2,
          label: '电子电器',
        },
        {
          id: 3,
          label: '食品行业',
        },
        {
          id: 4,
          label: '综合集团',
        },
      ],
      partnerList: [
        // 'partner1',
        // 'partner2',
        // 'partner3',
        // 'partner4',
        // 'partner5',
        // 'partner6',
        // 'partner7',
      ],
      enterprisePartnerScrollTimer: null,
    };
  },
  mounted () {
    this.CaseId = this.$route.params.id;
    this.getCaseInfo();
    this.getPartner();
    // this.playVideo();
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.enterprisePartnerScroll());
  },
  methods: {
    getCaseInfo() {
      getContentDetail(this.CaseId).then((res) => {
        const { result, } = res;
        const elements = result.elements;
        this.customerName = result.title;
        var chapterNum = elements.find(obj => obj.name === 'chapterNum');
        for (var i = 0; i < chapterNum.content; i++) {
          var contentItem = {
            icon: elements.find(item => item.name === 'icon' + (i + 1)).content,
            title: elements.find(item => item.name === 'title' + (i + 1)).content,
            img: elements.find(item => item.name === 'img' + (i + 1)).content,
            content: '',
          };
          const content = elements.find(item => item.name === 'content' + (i + 1)).content;
          var doc = new DOMParser().parseFromString(content, 'text/html');
          contentItem.content = doc.documentElement.textContent.replace(/&nbsp;/g, ' ');
          this.contentList.push(contentItem);
        }
        this.relatedProducts = JSON.parse(elements.find(obj => obj.name === 'relatedProducts').content);
      });
    },

    // 合作伙伴列表
    getPartner() {
      var params = { columnId: '1605405080163672064', pageNum: 1, pageSize: 99, commendation: 16, cascade: true, };
      getContentList(params).then((res) => {
        const { result, } = res;
        for (var i = 0; i < result.data.length; i++) {
          this.partnerList.push(result.data[i].logo);
        }
        this.$nextTick(() => {
          this.enterprisePartnerScroll();
          window.addEventListener('resize', this.enterprisePartnerScroll());
        });
      });
    },

    viewDetails(id) {
      if (id === 0) {
        this.$router.push({ path: '/strategyorganize', });
      } else if (id === 1) {
        this.$router.push({ path: '/staffmanage', });
      } else if (id === 2) {
        this.$router.push({ path: '/workinghours', });
      } else if (id === 3) {
        this.$router.push({ path: '/paywelfare', });
      } else if (id === 4) {
        this.$router.push({ path: '/personnelrecruit', });
      } else if (id === 5) {
        this.$router.push({ path: '/personnelgrow', });
      } else if (id === 6) {
        this.$router.push({ path: '/achievementview', });
      } else if (id === 7) {
        this.$router.push({ path: '/development', });
      }
    },
    viewCases(i) {
      this.$router.push({ name: 'CustomerCase', params: { label: i.label, }, });
    },
    partnerRecursion () {
      return true;
    },
    enterprisePartnerScroll () {
      const el = this.$refs.enterprisePartnerItemWrap;
      if (el.scrollWidth - el.offsetWidth > 10) {
        clearInterval(this.enterprisePartnerScrollTimer);
        const lenPx = this.partnerList.length * 135;
        el.style = `--parnertwrapscrollWidth: ${lenPx}px;--parnertwrapscrollhiddenWidth: ${lenPx}px`;
        // el.style = `--parnertwrapscrollWidth: ${el.clientWidth}px;--parnertwrapscrollhiddenWidth: ${lenPx}px`;
      }
      this.$refs.enterprisePartner.style = "display: none"
      setTimeout(() => {
        this.$refs.enterprisePartner.style = "display: block"
      },50)
    },
    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less" scoped>
.case-index{
    background-color: #fff;
    .page-content{
        width: 100%;
        .page-canvas{
            width: 100%;
            height: 360px;
            min-width: var(--minwidth);
            // position: relative;
            background: url('@/assets/customer/canvas.png') no-repeat;
            background-size: cover;
            background-position: center;
            .por-container{
                width: 70%;
                min-width: var(--minwidth);
                margin: 0 auto;
                position: relative;
                .page-info{
                    width: 40%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    padding-top: 119px;
                    box-sizing: border-box;
                    .page-info-title{
                        color: #fff;
                        font-size: 36px;
                        font-weight: 300;
                        line-height: 1;
                        margin-bottom: 30px;
                    }
                    .page-info-describe{
                        color: #fff;
                        font-size: 20px;
                        font-weight: 300;
                        line-height: 1;
                    }
                }
            }
        }
        .case-content-wrap{
            width: 1200px;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 60px;
            .case-breadcrumb-wrap{
                width: 100%;
                height: 63px;
                border-bottom: 2px solid #e8ecf3;
                padding-left: 1px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                margin-bottom: 40px;
                ::v-deep .el-breadcrumb{
                    .el-breadcrumb__item{
                        .el-breadcrumb__inner.is-link{
                            color: #00b0dc;
                            font-weight: 400
                        }
                    }
                }
            }
            .case-content{
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              margin-bottom: 20px;
              .case-content-left{
                width: 860px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                .text-module{
                  width: 100%;
                  .module-name-wrap{
                    width: 100%;
                    height: 48px;
                    background-color: #f5f5f6;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    .module-icon{
                      width: 48px;
                      height: 48px;
                      background-color: #00b0dc;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    }
                    .module-title{
                      margin-left: 16px;
                      font-size: 16px;
                      color: #181818;
                    }
                  }
                  .module-content-wrap{
                    width: 100%;
                    padding: 23px 0 38px;
                    box-sizing: border-box;
                    .content-img{
                      float: right;
                      margin-left: 40px;
                    }
                    .module-content{
                      shape-outside: circle(100%);
                      color: #181818;
                      font-size: 14px;
                      line-height: 24px;
                    }
                  }
                }
              }
              .case-content-right{
                width: 300px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
                .related-products{
                  width: 100%;
                  background-color: #fff;
                  border: 1px solid #e8ecf3;
                  box-sizing: border-box;
                  margin-bottom: 20px;
                  .wrap-name-box{
                    width: 100%;
                    height: 48px;
                    background-color: #0a1d2e;
                    padding: 0 16px;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    .wrap-name{
                      font-size: 16px;
                      color: #fff;
                    }
                  }
                  .product-list{
                    width: 100%;
                    padding: 0 20px;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: center;
                    box-sizing: border-box;
                    .product-item{
                      width: 100%;
                      border-bottom: 1px solid #e8ecf3;
                      padding: 23px 0 24px;
                      box-sizing: border-box;
                      display: flex;
                      flex-direction: column;
                      justify-content: flex-start;
                      align-items: flex-start;
                      .title{
                        font-size: 14px;
                        line-height: 1;
                        color: #181818;
                        margin-bottom: 18px;
                      }
                      .describe{
                        font-size: 14px;
                        line-height: 1;
                        color: #737c8b;
                        margin-bottom: 17px;
                      }
                      .product-btn{
                        width: 103px;
                        height: 32px;
                        background-color: #fff;
                        border: 1px solid #00b0dc;
                        text-align: center;
                        line-height: 32px;
                        color: #00b0dc;
                        font-size: 14px;
                        cursor: pointer;
                      }
                    }
                    .product-item:last-child{
                      border: none;
                    }
                  }
                }
                .more-cases{
                  width: 100%;
                  background-color: #fff;
                  box-sizing: border-box;
                  .wrap-name-box{
                    width: 100%;
                    height: 48px;
                    background-color: #0a1d2e;
                    padding: 0 16px;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    .wrap-name{
                      font-size: 16px;
                      color: #fff;
                    }
                  }
                  .cases-type-list{
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: flex-start;
                    align-items: flex-start;
                    .cases-type-item{
                      width: 140px;
                      height: 30px;
                      margin: 20px 20px 0 0;
                      background-color: #fff;
                      border: 1px solid #e8ecf3;
                      box-sizing: border-box;
                      text-align: center;
                      line-height: 30px;
                      font-size: 14px;
                      color: #737c8b;
                      cursor: pointer;
                    }
                    .cases-type-item:nth-child(2n){
                      margin-right: 0;
                    }
                  }
                }
              }
            }
            .enterprise-partner{
              width: 100%;
              height: 89px;
              overflow: hidden;
              img{
                width: 100%;
                height: 89px;
              }
              .enterprise-partner-item-wrap{
                // border: 1px solid
                height: 82px;
                position: relative;
                top: -90px;
                left: 115px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: calc(100% - 116px);
                overflow: scroll;
                .enterprise-partner-item{
                  flex-shrink: 0;
                  min-width: 135px;
                  padding: 0 5px;
                  animation: scrollbarpartner infinite;
                  animation-timing-function: linear;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  img{
                    width: auto;
                    height: 52px;
                  }
                }
              }
            }
            .enterprise-partner-item-wrap::-webkit-scrollbar{
              width:0px !important; /*高宽分别对应横竖滚动条的尺寸*/
              height: 0px;
            }
            .enterprise-partner-item-wrap::-webkit-scrollbar-thumb{
              border-radius: 0px !important;
              background: #acacac !important;
            }
            @keyframes scrollbarpartner {
              0% {
                transform: translateX(0)
                // transform: translateX(var(--parnertwrapscrollWidth));
              }
              100% {
                // transform: translateX(var(--parnertwrapscrollWidth));
                // transform: translateX(0)
                transform: translateX(calc(var(--parnertwrapscrollhiddenWidth) * -1));
              }
            }
        }
        .appointment-demonstration{
          width: 100%;
          min-width: var(--minwidth);
          height: 188px;
          background-image: url('@/assets/home/appointment-demonstration.png');
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
          text-align: center;
          color: #fff;
          padding: 22px;
          box-sizing: border-box;
          .appointment-demonstration-title{
            font-size: 26px;
            color: #fff;
            margin-bottom: 20px;
          }
          .appointment-demonstration-subtitle{
            font-size: 16px;
            font-weight: 400;
            color: #fff;
            margin-bottom: 25px;
          }
          .appointment-demonstration-btn{
            width: 220px;
            height: 46px;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: auto;
            background: #00b0dc;
            border-radius: 30px;
            cursor: pointer;
            img{
              width: 18px;
              height: 22px;
              vertical-align: middle;
              margin-right: 10px
            }
            transition: all 0.5s;
            &:hover{
              transform: scale(1.1);
              transition: all  0.5s;
            }
          }
        }
    }
}
</style>
